import React from 'react';

import { Grid, Typography, makeStyles, useTheme } from '@material-ui/core';
import i18n from 'i18n';
import {
  AvgMaxCountAccess,
  PeriodCountAccess,
  DateFilterFields,
} from 'modules/environments/interfaces';
import ApplicationState from 'store/interfaces';
import { connect } from 'react-redux';
import AutoCard from 'components/AutoCard';
import FilterSelector from 'components/FilterSelector';
import { filterAvgMaxOptions } from 'utils/graphs';
import {
  getEnvironmentPerformanceCPURequest,
  setEnvironmentAvgMaxFilterCPU,
} from 'modules/environments/actions';
import { useParams } from 'react-router';
import { modalOpen } from 'modules/modal/actions';
import { ModalFields } from 'modules/modal/interfaces';
import CPUGraph from './CPUGraph';
import styles, {
  overrideCardGraph,
  overrideFilter,
  overrideModalGraph,
} from './styles';
import CPUGraphModal from './CPUGraphModal';

interface CPUGraphCardProps {
  avgMaxFilter: AvgMaxCountAccess;
  dateFilter?: DateFilterFields;
  intervalTime: PeriodCountAccess;
  modalOpen: (props: ModalFields) => void;
  setEnvironmentAvgMaxFilterCPU: (prop: string) => void;
  getEnvironmentPerformanceCPURequest: ({ id, query }) => void;
}

const CPUGraphCard = ({
  avgMaxFilter,
  dateFilter,
  intervalTime,
  modalOpen,
  setEnvironmentAvgMaxFilterCPU,
  getEnvironmentPerformanceCPURequest,
}: CPUGraphCardProps) => {
  const classes = makeStyles(styles())();
  const { id } = useParams<{
    id: string;
  }>();
  const { breakpoints } = useTheme();

  const getEnvironmentPerformanceCPU = React.useCallback(() => {
    const query =
      dateFilter?.['start-date'] && dateFilter?.['end-date']
        ? dateFilter
        : { period: intervalTime };

    getEnvironmentPerformanceCPURequest({
      id,
      query,
    });
  }, [getEnvironmentPerformanceCPURequest, intervalTime, id, dateFilter]);

  React.useEffect(() => {
    getEnvironmentPerformanceCPU();
  }, [getEnvironmentPerformanceCPU]);

  const handleOpenGraphModal = () => {
    modalOpen({
      overrideClasses: overrideModalGraph,
      maxWidth: 'xl',
      title: i18n.t('PERFORMANCE_PAGE.CPU_USE_DETAILS_KEY'),
      content: <CPUGraphModal />,
      onClose: () => getEnvironmentPerformanceCPU(),
      genericFooter: {},
    });
  };

  return (
    <Grid item className={classes.containerCard}>
      <Grid item>
        <Grid container alignItems="center" justify="space-between">
          <Grid item>
            <Typography className={classes.graphTitle}>
              {i18n.t('PERFORMANCE_PAGE.CPU_USE_KEY')}
            </Typography>
          </Grid>
          <Grid item className={classes.gridFilters}>
            <FilterSelector
              overrideClasses={overrideFilter}
              options={filterAvgMaxOptions(setEnvironmentAvgMaxFilterCPU)}
              currentValue={{
                label: i18n.t(
                  `PERFORMANCE_PAGE.${avgMaxFilter.toUpperCase()}_KEY`
                ),
                onClick: () => null,
              }}
            />
          </Grid>
        </Grid>
      </Grid>
      <AutoCard overrideClasses={overrideCardGraph(breakpoints)}>
        <Grid
          container
          className={classes.containerGraph}
          onClick={handleOpenGraphModal}
        >
          <CPUGraph filter={avgMaxFilter} />
        </Grid>
      </AutoCard>
    </Grid>
  );
};

const mapStateToProps = ({
  environments: { periodFilter, environmentAvgMaxFilterCPU },
}: ApplicationState) => ({
  intervalTime: periodFilter,
  avgMaxFilter: environmentAvgMaxFilterCPU,
});
export default connect(mapStateToProps, {
  setEnvironmentAvgMaxFilterCPU,
  getEnvironmentPerformanceCPURequest,
  modalOpen,
})(CPUGraphCard);
